import React, { useEffect, useState, FormEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { getAcaoById, updateAcao } from "../../../../api/acaoApi";
import Formulario, { FormField } from "../../../../components/Formulario";

const EditarAcao: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [checklist, setChecklist] = useState<number>(0);
  const [clienteObrigatorio, setClienteObrigatorio] = useState<boolean>(false);
  const [entrega, setEntrega] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [updating, setUpdating] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAcao = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const acaoData = await getAcaoById(token, id!);
        setChecklist(acaoData.id_checklist);
        setClienteObrigatorio(acaoData.cliente_obrigatorio_acoes);
        setEntrega(acaoData.entrega_acao);
      } catch (error) {
        toast.error("Erro ao buscar Ação!");
        console.error("Erro ao buscar Ação:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAcao();
  }, [id]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setUpdating(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }

      await updateAcao(token, id!, {
        id_checklist: checklist,
        cliente_obrigatorio_acoes: clienteObrigatorio,
        entrega_acao: entrega,
      });
      toast.success("Ação atualizada com sucesso!");
      navigate("/acoes");
    } catch (error) {
      toast.error("Erro ao atualizar Ação!");
      console.error("Erro ao atualizar Ação:", error);
    } finally {
      setUpdating(false);
    }
  };

  const handleBack = () => {
    navigate("/acoes");
  };

  const fields: FormField[] = [
    {
      label: "Checklist",
      type: "number",
      value: checklist,
      required: true,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setChecklist(Number(e.target.value))
    },
    {
      label: "Cliente Obrigatório",
      type: "checkbox",
      value: clienteObrigatorio,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setClienteObrigatorio(e.target.checked)
    },
    {
      label: "Entrega da Ação",
      type: "checkbox",
      value: entrega,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setEntrega(e.target.checked)
    }
  ];

  return (
    <Formulario
      title="Editar Ação"
      fields={fields}
      onSubmit={handleSubmit}
      onBack={handleBack}
      loading={loading || updating}
    />
  );
};

export default EditarAcao;
